/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const SABRE_PRODUCT_MODEL_EXCLUSION_FRAGMENT = gql`
  fragment ProductModelExclusion on Product {
    id
    upcA
    preferredName
    packagingName
    excludedFromModels
  }
`
